import { PHASE_META, type FlowPhase } from "./flowData";

interface PhaseBannerProps {
  phase: FlowPhase;
}

/**
 * Bold section banner separating Digital Mapping / Physical Mapping / Export.
 * Large icon chip in the phase accent color, label heading and tagline.
 */
export function PhaseBanner({ phase }: PhaseBannerProps) {
  const meta = PHASE_META[phase];
  const Icon = meta.icon;
  const stepCount = meta.stepNumbers.length;
  return (
    <div className={`border-l-4 ${meta.color.border} pl-4 md:pl-5`}>
      <div className="flex items-center gap-4">
        <div
          className={`flex items-center justify-center size-12 rounded-xl shrink-0 ${meta.color.bg}`}
        >
          <Icon className={`size-6 ${meta.color.text}`} />
        </div>
        <div className="min-w-0">
          <div className="flex items-baseline gap-2 flex-wrap">
            <h2 className="text-xl md:text-2xl font-bold text-foreground">
              {meta.label}
            </h2>
            <span className={`text-xs font-semibold uppercase tracking-wide ${meta.color.text}`}>
              {stepCount} {stepCount === 1 ? "step" : "steps"}
            </span>
          </div>
          <p className="text-sm text-muted-foreground mt-0.5">{meta.tagline}</p>
        </div>
      </div>
    </div>
  );
}
